'use strict';

import quantityControl from '../modules/QuantityControl';
import debounce from '../modules/debounce';

export default function(element) {
  quantityControl(element);
  element.delegate('[data-item-remove]', 'click', function() {
    const entryNumber = $(this).data('entry-number');
    const form = $('#updateCartForm' + entryNumber);

    const productCode = form.find('input[name=productCode]').val();
    const initialCartQuantity = form.find('input[name=initialQuantity]');
    const cartPrice = $(form).attr('data-price');
    const cartName = $(form).attr('data-name');

    ACC.track.trackRemoveFromCart(productCode, initialCartQuantity.val(), cartName, cartPrice);
  });

  const debouncer = debounce(1000, function(form) {
    const productCode = form.find('input[name=productCode]').val();
    const initialCartQuantity = form.find('input[name=initialQuantity]').val();
    const newCartQuantity = form.find('input[name=quantity]').val();
    const cartPrice = form.attr('data-price');
    const cartName = form.attr('data-name');
    const entry = form.find('.js-remove-cart-entry');
    const brand = entry.attr('data-brand');
    const category = entry.attr('data-category');
    const color = entry.attr('data-color');
    const size = entry.attr('data-size');

    if (initialCartQuantity != newCartQuantity) {
      $('[data-loading-mask]').removeClass('hide');
      $('.loading-masked').fadeTo(1, 0.3);

      ACC.track.trackUpdateCart(
        productCode,
        initialCartQuantity,
        newCartQuantity,
        cartName,
        cartPrice,
        brand,
        category,
        color,
        size
      );

      $.ajax({
        url: $(form).attr('action'),
        type: 'POST',
        data: $(form).serialize(),
        dataType: 'json',
        error: function() {
          $('[data-loading-mask]').addClass('hide');
          $('.loading-masked').fadeTo(1, 1);
        },
        complete: function() {
          $('[data-loading-mask]').addClass('hide');
          $('.loading-masked').fadeTo(1, 1);
        },
        success: function(data) {
          $('#cartBody').html(data.html);
          let sum = 0;
          const lines = $('input[name=quantity]');
          for (let i = 0; i < lines.length; i++) {
            sum += parseInt($(lines[i]).val());
          }
          $("[id='miniCartItemCount']").text(sum);
        },
      });
    }
  });

  $(document).delegate('.order-items-checkout form', 'submit', function(event) {
    event.preventDefault();
    debouncer($(this));
  });

  $(document).delegate('input[name=quantity]', 'keyup', function(event) {
    debouncer($(event.target).closest('form'));
  });

  $(document).on('quantity-change', function(event, target) {
    debouncer($(target).closest('form'));
  });
}
